/**
 * Waits until the given condition is met or until the maximum waiting time is reached.
 * @param condition Function that checks the waiting condition.
 * @param maxWait Maximum waiting time (in milliseconds). Default: 5000ms.
 * @param checkInterval Interval to check the condition (in milliseconds). Default: 100ms.
 * @returns Promise resolved with the total time waited when the condition is met,
 * or rejected after reaching the maximum time.
 */
export default async function waitUntil(
    condition: () => boolean,
    maxWait: number = 5000,
    checkInterval: number = 100
): Promise<number> {
    let totalTime = 0;

    while (!condition()) {
        if (totalTime >= maxWait) {
            return Promise.reject(new Error(`Maximum waiting time of ${maxWait}ms exceeded!`));
        }

        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, checkInterval));

        totalTime += checkInterval;
    }

    return Promise.resolve(totalTime);
}
